// custom-bundle-fix.js
(function() {
  function markSelectOptions() {
    document.querySelectorAll('select').forEach(function(sel) {
      sel.querySelectorAll('option').forEach(function(opt) {
        if (opt.disabled || /agotad|no disponible|sold out/i.test(opt.textContent)) {
          opt.classList.add('size-soldout-option');
          // añadir texto explícito si no lo tiene
          if (!/agotad|no disponible|sold out/i.test(opt.textContent)) {
            opt.textContent = opt.textContent + ' (AGOTADO)';
          }
        }
      });
    });
  }

  function markButtonsAndPills() {
    // 1) Target común de AvisPlus y widgets: muchas veces usan clases que contienen "apb" o "bundle" o "variant"
    var selectors = [
      '.apb-option',      // AvisPlus common class (ejemplo)
      '.apb-variant',     // alternativa
      '.bundle-option',   // posible variante
      '.swatch',          // swatches genéricos
      '.variant',         // genérico
      '[data-option]',    // fallback data-attr
      '[role="option"]'   // accesible role
    ];
    var els = document.querySelectorAll(selectors.join(', '));

    els.forEach(function(el) {
      // Si el propio elemento contiene texto que indica agotado
      var txt = (el.innerText || el.textContent || '').trim();
      if (/agotad|no disponible|sold out/i.test(txt)) {
        el.classList.add('size-soldout');
        // si no contiene la palabra AGOTADO explícita, añadir badge
        if (!/agotad|no disponible|sold out/i.test(txt)) {
          var badge = document.createElement('span');
          badge.className = 'soldout-badge-inline';
          badge.textContent = 'AGOTADO';
          el.appendChild(badge);
        }
      }
      // Si el elemento está marcado con atributo disabled
      if (el.hasAttribute && el.hasAttribute('disabled')) {
        el.classList.add('size-soldout');
      }
    });

    // 2) Fallback: en la página el texto "Variante agotada o no disponible" aparece.
    // Buscamos ese texto y tachamos la opción correspondiente (por proximidad).
    document.querySelectorAll('body *').forEach(function(node) {
      if (node.childElementCount === 0 && /Variante agotada|no disponible|Agotado/i.test(node.textContent || '')) {
        // subimos hasta el contenedor del producto y buscamos elementos con texto de talla
        var container = node.closest('.product-form') || node.closest('.product') || node;
        if (container) {
          // busca nodes que parezcan opciones de talla cerca (labels, buttons, spans)
          container.querySelectorAll('button, a, span, label, div').forEach(function(candidate) {
            var ctext = (candidate.innerText || candidate.textContent || '').trim();
            // si el texto coincide con patrones de talla (S, M, L, XL, 2XL, 3XL)
            if (/\b(XXL|2XL|3XL|XL|L|M|S)\b/i.test(ctext) && !/precio|descuento|oferta/i.test(ctext)) {
              // si el candidate tiene alguna referencia a "agotado" dentro del container, márcalo
              if (/\b(2XL|XXL|3XL)\b/i.test(node.textContent || '') && /\b(2XL|XXL|3XL)\b/i.test(ctext)) {
                candidate.classList.add('size-soldout');
              }
            }
          });
        }
      }
    });
  }

  // Ejecuta al inicio y también cuando cambie el DOM (AvisPlus inyecta HTML dinámicamente)
  function runAll() {
    try {
      markSelectOptions();
      markButtonsAndPills();
    } catch (e) {
      // fail silently
      console.warn('bundle-fix error', e);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Observe mutations (apps like AvisPlus actualizan el DOM después)
  var observer = new MutationObserver(function(mutations) {
    runAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Small utility: re-run after 1.5s and 4s (catch late loads)
  setTimeout(runAll, 1500);
  setTimeout(runAll, 4000);
})();
